import { Card } from "grommet"
import './styles/OverlayPreviewCard.css'
import { SnowCanvas } from "./SnowCanvas"
import { useSettingsContext } from "./SettingsContextProvider"

export const OverlayPreviewCard = () => {

    const { settingsContext } = useSettingsContext();

    return (
        <Card height={'100vh'}>
            {settingsContext && <SnowCanvas
                intensity={Number(settingsContext.intensity)}
                fallSpeed={Number(settingsContext.fallSpeed)}
                wind={Number(settingsContext.windDirection)}
                snowSize={Number(settingsContext.snowSize)}
                accumulate={settingsContext.enableSnowDrifts}
                maxDriftHeight={Number(settingsContext.maxDriftHeight)}
                meltSimulation={settingsContext.meltSimulation}
                meltSpeed={Number(settingsContext.meltSpeed)}
                weatherSim={settingsContext.weatherSim}
            />}
        </Card>
    )
}